import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; 
import ScrollToTop from "./components/ScrollToTop";
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Banner from './components/BAnner';
import About from './components/About';
import Service1 from './components/Service1';
import ServiceHome from './components/ServiceHome';
// import Service2 from './components/Service2';
import Serviceweb from './components/service_web';
import ServicewebModasa from './components/service_website_modasa';
import WebsiteDevelopmentAravalli from './components/websiteDevelopmentAravalli';
import WebsiteDevelopmentOman from './components/websiteDevelopmentOman';
import WhatsappCrmAravalli from './components/whatsappCrmAravalli';
import ServiceSoftwareModasa from './components/service_software_modasa';
import ServiceDigitalModasa from './components/service_digital_modasa';
import SoftwareDevelopment from './components/softwareDevelopment';
import MobileAppDevelopmentServices from './components/mobileAppDevelopmentServices';
import AiAgentDevelopment from './components/aiAgentDevelopment';
import DigitalMarketingServices from './components/digitalMarketingServices';
import SeoService from './components/seoService';
import GoogleAdsService from './components/googleAdsService';
import SocialMediaMarketing from './components/socialMediaMarketing';
import ContentWritingServices from './components/contentWritingServices';
import WebDesigningCourseModasa from './components/webDesigningCourseModasa';
import WebDevelopmentCourseModasa from './components/webDevelopmentCourseModasa';
import DigitalMarketingCourseModasa from './components/digitalMarketingCourseModasa';
import MobileAppDevelopment from './components/mobileAppDevelopment';
import BCAIndInt from './components/bcaInternshipIndustrial';
import IndProjIntMent from './components/internshipProjectMentorship';
import IntProjGuid from './components/internshipProjectGuidance';
import BtechIntProjGuid from './components/BebTechinternshipProjectGuidance';
import QATesting from './components/QA_Testing';
import ServiceCrm from './components/service_crm';
import ProductWhatsappCrm from './components/product_whatsapp_crm';
import ProductMedicalWholesaleRetailApp from './components/product_medical_wholesale_retail_app';
import ProductSchoolManagement from './components/product_school_management';
import ServiceErp from './components/services_erp';
import ServiceExtension from './components/service_extension';
import PreBusiness from './components/PreBusiness';
import Project from './components/Project';
import ClientLogos from './components/ClientLogos';
import VideoTestimonials from './components/VideoTestimonials';
import TechnologyPartners from './components/TechnologyPartners';
import IndustriesSection from './components/IndustriesSection';
import ReviewPlatforms from './components/ReviewPlatforms';
import FreeBusinessReview from './components/FreeBusinessReview';
import SwiftMazeStory from './components/SwiftMazeStory';
// import RecentProject from './components/RecentProject';
import Technology from './components/Technology';
// import Team from './components/Team';
// import Blog from './components/Blog';
import Footer from './components/Footer';
// import ProjectDetailsScrapper from './components/ProjectDetails_scrapper';
// import ProjectDetailsFull2sms from './components/ProjectDetails_Full2sms';
import ServiceDetails from './components/ServiceDetails';
import Contact from './components/Contact';
import Service_top from './components/Service_top';
import Project_top from './components/Project_top';
import About_main from './components/About_main';
import PrivcyPolicy from './components/Privacy_policy';
import TermsAndConditions  from './components/Terms_and_Conditions';
import RefundPolicy  from './components/Refund_Policy';
import HomeSEO from './components/HomeSEO';
import NotFound from './components/NotFound'
import BenefitsSection from './components/BenefitsSection';
import ProjectContactSection from './components/ProjectContactSection'
import ChatWithSwiftmaze from './components/ChatWithSwiftmaze';
import HomeProductsSection from './components/HomeProductsSection';
function App() {
  const [showSlider, setShowSlider] = useState(false);
  const toggleSlider = () => {
    setShowSlider(!showSlider);
  };

  const Section = ({ children }) => (
  <section className="section-space">{children}</section>
);
  return (  
    <HelmetProvider>
      <BrowserRouter>
        <>
          <ScrollToTop />
          <Header toggleSlider={toggleSlider} />
          <Routes>
          <Route path="/" element={
            <>
              <HomeSEO />
              {/* <Banner /> */}
              {/* <About />
              <ServiceHome />
              <PreBusiness />
              <Sponsors />
              <Technology />
             <BenefitsSection/>
             <ProjectContactSection/> */}
             <section className="section-space--banner"><Banner /></section>
            <section className="section-space"><About /></section>
            <section className="section-space"><ClientLogos /></section>
            <section className="section-space"><VideoTestimonials /></section>
            <section className="section-space"><TechnologyPartners /></section>
            <section className="section-space"><ServiceHome /></section>
            <section className="section-space"><PreBusiness /></section>
            <section className="section-space"><HomeProductsSection /></section>
            <section className="section-space"><IndustriesSection /></section>
            <section className="section-space"><ReviewPlatforms /></section>
            <section className="section-space"><FreeBusinessReview /></section>
            <section className="section-space"><SwiftMazeStory /></section>
            {/* <section className="section-space"><Sponsors /></section> */}
            <section className="section-space"><BenefitsSection /></section>
            <section className="section-space"><Technology /></section>
        
            <section className="section-space"><ProjectContactSection /></section>

            </>
          }/>
          <Route path="/about" element={<><About_main/> </>} />
          <Route path="/services" element={<><Service_top/><Service1 /></>} />
          <Route path="/serviceDetails" element={<ServiceDetails />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/services/web-development" element={<Serviceweb />} />
          <Route path="/services/website-development-company-aravalli" element={<WebsiteDevelopmentAravalli />} />
          <Route path="/services/website-development-agency-oman" element={<WebsiteDevelopmentOman />} />
          <Route path="/services/whatsapp-crm-aravalli" element={<WhatsappCrmAravalli />} />
          <Route path="/services/software-development" element={<SoftwareDevelopment />} />
          <Route path="/services/software-development-modasa" element={<ServiceSoftwareModasa />} />
          <Route path="/services/software-development-company-modasa" element={<Navigate to="/services/software-development-modasa" replace />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopmentServices />} />
          <Route path="/services/mobile-app-development-modasa" element={<MobileAppDevelopment />} />
          <Route path="/services/ai-agent-development" element={<AiAgentDevelopment />} />
          <Route path="/services/digital-marketing-services" element={<DigitalMarketingServices />} />
          <Route path="/services/seo-service" element={<SeoService />} />
          <Route path="/services/google-ads" element={<GoogleAdsService />} />
          <Route path="/services/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/services/content-writing-services" element={<ContentWritingServices />} />
          
          <Route path="/services/website-development-modasa" element={<ServicewebModasa />} />
          <Route path="/services/digital-marketing-modasa" element={<ServiceDigitalModasa />} />
          <Route path="/training/web-designing-course-modasa" element={<WebDesigningCourseModasa />} />
          <Route path="/training/web-development-course-modasa" element={<WebDevelopmentCourseModasa />} />
          <Route path="/training/digital-marketing-course-modasa" element={<DigitalMarketingCourseModasa />} />
          <Route path="/training/bca-internship-industrial-project-guidance" element={<BCAIndInt/>} />
          <Route path="/training/industry-project-internship-mentorship" element={<IndProjIntMent />} />
          <Route path="/training/internship-project-guidance-modasa" element={<IntProjGuid />} />
          <Route path="/training/btech-be-internship-project-guidance" element={<BtechIntProjGuid />} />

          <Route path="/services/web-designing-course-modasa" element={<Navigate to="/training/web-designing-course-modasa" replace />} />
          <Route path="/services/web-development-course-modasa" element={<Navigate to="/training/web-development-course-modasa" replace />} />
          <Route path="/services/digital-marketing-course-modasa" element={<Navigate to="/training/digital-marketing-course-modasa" replace />} />
          <Route path="/services/bca-internship-industrial-project-guidance" element={<Navigate to="/training/bca-internship-industrial-project-guidance" replace />} />
          <Route path="/services/industry-project-internship-mentorship" element={<Navigate to="/training/industry-project-internship-mentorship" replace />} />
          <Route path="/services/internship-project-guidance-modasa" element={<Navigate to="/training/internship-project-guidance-modasa" replace />} />
          <Route path="/services/btech-be-internship-project-guidance" element={<Navigate to="/training/btech-be-internship-project-guidance" replace />} />
          <Route path="/services/qa-testing" element={<QATesting/>} />

          <Route path="/services/hire-chrome-extension-developer" element={<ServiceExtension />} />
          <Route path="/services/extension-development" element={<ServiceExtension />} />
          <Route path="/services/crm-development" element={<ServiceCrm />} />
          <Route path="/services/whatsapp-crm" element={<Navigate to="/products/whatsapp-crm" replace />} />
          <Route path="/services/whatsapp-crm/" element={<Navigate to="/products/whatsapp-crm" replace />} />
          <Route path="/products" element={<Navigate to="/products/whatsapp-crm" replace />} />
          <Route path="/products/" element={<Navigate to="/products/whatsapp-crm" replace />} />
          <Route path="/products/whatsapp-crm" element={<ProductWhatsappCrm />} />
          <Route path="/products/whatsapp-crm/" element={<ProductWhatsappCrm />} />
          <Route
            path="/products/school-management"
            element={<ProductSchoolManagement />}
          />
          <Route
            path="/products/school-management/"
            element={<ProductSchoolManagement />}
          />
          <Route
            path="/products/medical-wholesale-retail-app"
            element={<ProductMedicalWholesaleRetailApp />}
          />
          <Route
            path="/products/medical-wholesale-retail-app/"
            element={<ProductMedicalWholesaleRetailApp />}
          />
          <Route path="/services/erp-development" element={<ServiceErp />} />
          
          <Route path="/privacy-policy" element={<PrivcyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <ChatWithSwiftmaze />
          <Sidebar show={showSlider} toggleSlider={toggleSlider} />
        </>
      </BrowserRouter>
    </HelmetProvider>
  );
}
export default App;
